// extracted by mini-css-extract-plugin
export var errorsContainer = "_q1-1";
export var link = "_q1-0";